// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import PropTypes from 'prop-types'
import { TrackingProvider } from '@indeed/flex-tracking-context'

import EmployerBlocklistList from '../../entities/EmployerDetail/EmployerBlocklistList'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'

const EmployerBlocklistListView = ({ match: { params } }) => (
  <TrackingProvider
    value={{
      context: {
        employer_id: Number(params.id),
      },
    }}
  >
    <div className="page entity-list">
      <SubNavigation subPage="employers" data={{ employerID: Number(params.id) }} />
      <EmployerBlocklistList employerID={Number(params.id)} />
    </div>
  </TrackingProvider>
)
EmployerBlocklistListView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      // Note: ID gets passed as a string directly from the URL.
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default EmployerBlocklistListView
